export enum DtwinOperationTypes {
  CERT_RENEW = "CERT_RENEW",
  FIRMWARE_UPDATE = "FIRM_UPDATE",
}
